// Catalog browsing groups use the saved being type, never the template's name or prose.
const plants = new Set([
  'Tree', 'Bush', 'Shrub', 'Herbaceous Plant', 'Grass', 'Vine', 'Fern', 'Moss',
  'Succulent', 'Aquatic Plant', 'Eldar', 'Auneth', 'Velmora', 'Osselin', 'Ithava',
  'Selquor', 'Emrathi', 'Neralva', 'Ulvor', 'Kessari', 'Rhavul', 'Oruneth',
  'Talquess', 'Ivranel', 'Dhurvek', 'Vaskhul', 'Zerunai', 'Qharrun', 'Ulmorath',
  'Eshkora', 'Vezrath',
]);
const animals = new Set(['Mammal', 'Bird', 'Reptile', 'Amphibian', 'Fish', 'Invertebrate']);
const races = new Set([
  'Human', 'Elf', 'Dark Elf', 'Dwarf', 'Halfling', 'Gnome', 'Orc', 'Goblin',
  'Draki', 'Lizki', 'Almani', 'Centaur', 'Giant', 'Troll', 'Ogre',
  'Bugbear', 'Merrow', 'Minotaur', 'Satyr', 'Triton', 'Brownie', 'Dryad', 'Pixie',
  'Sprite', 'Sylph',
]);

export const beingTemplateCategories = ['Plants', 'Animals', 'Races', 'Creatures'];
export const getBeingTemplateCategory = type => {
  if (!type) return null;
  if (plants.has(type)) return 'Plants';
  if (animals.has(type)) return 'Animals';
  if (races.has(type)) return 'Races';
  return 'Creatures';
};
